import { render, staticRenderFns } from "./TruckRightIcon.vue?vue&type=template&id=55af9e98&scoped=true&"
import script from "./TruckRightIcon.vue?vue&type=script&lang=js&"
export * from "./TruckRightIcon.vue?vue&type=script&lang=js&"
import style0 from "./TruckRightIcon.vue?vue&type=style&index=0&id=55af9e98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af9e98",
  null
  
)

export default component.exports